import React, { FunctionComponent } from 'react'
import Svg, { Circle } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

/**
 * Two columns of three dots indicating that an element can be dragged
 */
export const DragHandleIcon: FunctionComponent<DragHandleIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme() as ThemeType
  const fill = fillColor ?? colors.iconDefault

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
      {[6, 12, 18].map((cy) =>
        [9, 15].map((cx) => <Circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={1.75} fill={fill} />),
      )}
    </Svg>
  )
}

type DragHandleIconProps = {
  size?: string | number
  fillColor?: string
}
